export default "__VITE_ASSET__DKcxDvn$__"